import React, { useEffect, useState } from "react";
import { Row, Col, Form, Input } from "antd";
import { HeaderWithBottomLine } from "../HeaderWithBottomLine";
import urls from "../../../../api/urls";
import API from "../../../../api";
import {
  checkSpace,
  checkSpecialCharacter,
  checkNumbervalue,
  checkAlphabets,
  firstLetterCapitalise,
} from "../../../../utils";

function FirmBankDetails({ form }) {
  const [bankDetails, setBankDetails] = useState();
  const [validator, setValidator] = useState({});

  const { GET_BANK_DETAILS_BY_IFSC } = urls;

  useEffect(() => {
    if (bankDetails?.IFSC) {
      form.setFieldsValue({
        BankName: bankDetails?.BANK,
        branchName: bankDetails?.BRANCH,
      });
    }
  }, [bankDetails]);

  const checkIFSC = async (values) => {
    let response = await API.Api(
      GET_BANK_DETAILS_BY_IFSC + `?ifscCode=${values}`
    ).get();
    if (response.status) {
      setValidator({
        validateStatus: "success",
        errorMsg: null,
      });
      setBankDetails(response.response.data);
    } else {
      setValidator({
        validateStatus: "error",
        errorMsg: "Invalid IFSC code",
      });
      // message.error("Invalid IFSC code");
    }
  };
  const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
  const accountNumberRegex = /^[A-Za-z0-9]{9,25}$/;

  let lg = 12;
  let sm = 24;
  let md = 12;
  let xs = 24;
  return (
    <>
      <HeaderWithBottomLine text={"Firm Bank Details"} icon={false} />
      <Row gutter={40} className="basic-details-conten global-form-row">
        <Col lg={lg} md={md} sm={sm} xs={xs}>
          <Form.Item
            name="AccountHolderName"
            label={"Account holder’s name"}
            rules={[
              {
                required: true,
                message: "Please enter value",
              },
              () => ({
                validator(rule, value = "") {
                  if (value.substring(1, 0) === " ") {
                    return Promise.reject("Invalid Account holder’s name");
                  } else {
                    return Promise.resolve();
                  }
                },
              }),
            ]}
            onKeyPress={(event) => {
              if (checkSpecialCharacter(event)) {
                event.preventDefault();
              }
            }}
          >
            <Input
              placeholder="Enter account holder’s name"
              type="text"
              maxLength={50}
              // onBlur={(e) =>
              //   form.setFieldValue(
              //     "AccountHolderName",
              //     firstLetterCapitalise(e)
              //   )
              // }
              onInput={(e) => (e.target.value = firstLetterCapitalise(e))}
            />
          </Form.Item>
        </Col>

        <Col lg={lg} md={md} sm={sm} xs={xs}>
          <Form.Item
            name="AccountNo"
            label={
              <span className="calculater-container-pikpin">Account no</span>
            }
            rules={[
              {
                required: true,
                message: "Please enter value",
              },
              {
                pattern: accountNumberRegex,
                message: "Please enter a valid account number",
              },
            ]}
            onKeyPress={(event) => {
              if (
                // checkNumbervalue(event) ||
                checkSpecialCharacter(event) ||
                checkSpace(event)
              ) {
                event.preventDefault();
              }
            }}
          >
            <Input placeholder="Enter account no" type="text" maxLength={25} />
          </Form.Item>
        </Col>

        <Col lg={lg} md={md} sm={sm} xs={xs}>
          <Form.Item
            name="IFSCCode"
            label={
              <span className="calculater-container-pikpin">IFSC code</span>
            }
            rules={[
              {
                required: true,
                message: "Enter IFSC code!",
              },
              {
                pattern: ifscRegex,
                message: "Please enter a valid IFSC code",
              },
              // {
              //   pattern: "^[A-Za-z]{4}0[A-Z0-9a-z]{6}$",
              //   message: "Invalid IFCS code",
              //   validateTrigger: "onSubmit",
              // },
              // {
              //   max: 12,
              //   message: "Value should be less than 12 character",
              //   validateTrigger: "onSubmit",
              // },
            ]}
            onKeyPress={(event) => {
              if (checkSpecialCharacter(event) || checkSpace(event)) {
                event.preventDefault();
              }
            }}
            validateStatus={validator?.validateStatus}
            help={validator?.errorMsg}
          >
            <Input
              placeholder="Enter IFSC code"
              type="text"
              maxLength={11}
              onChange={(event) => {
                if (event.target.value.length > 10) {
                  checkIFSC(event.target.value);
                } else {
                  form.setFieldsValue({
                    BankName: "",
                    branchName: "",
                  });
                }
              }}
              onInput={(e) => (e.target.value = e.target.value.toUpperCase())}
            />
          </Form.Item>
        </Col>
        <Col lg={lg} md={md} sm={sm} xs={xs}>
          <Form.Item
            name="BankName"
            label={"Bank name"}
            onKeyPress={(event) => {
              if (checkAlphabets(event)) {
                event.preventDefault();
              }
            }}
          >
            <Input
              placeholder="Enter bank name"
              type="text"
              maxLength={30}
              disabled={true}
              onInput={(e) => (e.target.value = firstLetterCapitalise(e))}
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
}

export default FirmBankDetails;
